export const getCurrentEpochDates = (chartData: any[], zoomStartIndex: number, zoomEndIndex: number) => {
    const startDate = (chartData.length > 0 && zoomStartIndex >= 0 && zoomStartIndex < chartData.length && chartData[zoomStartIndex]?.timestamp)
        ? chartData[zoomStartIndex].timestamp
        : null;

    const endDate = (chartData.length > 0 && zoomEndIndex >= 0 && zoomEndIndex < chartData.length && chartData[zoomEndIndex]?.timestamp)
        ? chartData[zoomEndIndex].timestamp
        : null;

    return { startDate, endDate };
};

export const getZoomedData = (chartData: any[], zoomStartIndex: number, zoomEndIndex: number) => {
    if (chartData.length === 0 || zoomStartIndex < 0 || zoomEndIndex >= chartData.length || zoomStartIndex > zoomEndIndex) {
        return [];
    }
    return chartData.slice(zoomStartIndex, zoomEndIndex + 1);
};